<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>自媒体管理</a-breadcrumb-item>
    <a-breadcrumb-item>油管片库</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">剧名：</a-col>
          <a-col :span="18">
            <a-input v-model:value="nameModel" class="tool-item" placeholder="请输入名称" />
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">剧情频道：</a-col>
          <a-col :span="18">
            <a-select v-model:value="maleAndFemaleModel" class="tool-item" placeholder="请选择" allow-clear>
              <a-select-option v-for="item in PlotChannels" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">风格：</a-col>
          <a-col :span="18">
            <a-select v-model:value="styleTypeModel" class="tool-item" placeholder="请选择" allow-clear>
              <a-select-option v-for="item in StyleTypes" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">供应商：</a-col>
          <a-col :span="18">
            <a-select v-model:value="filmSupplierIdModel" class="tool-item" placeholder="请选择" allow-clear show-search :filter-option="filterSupplierOption">
              <a-select-option v-for="item in supplierList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row class="tool-row">
      <a-col :span="6">
        <a-button type="primary" @click="touchSearch">查询</a-button>
        <a-button style="margin-left: 16px" @click="touchReset">重置</a-button>
      </a-col>
      <a-col :span="6"></a-col>
      <a-col :span="12" style="text-align: right;">
        <Upload
          accept=".xlsx,.xls,.csv"
          uploadSource="YoutubeFilmlibrary"
          :beforeUploadPro="beforeUploadBatchPro"
          style="display: inline-block; margin-right: 16px;"
        >
          <template #up-title>批量创建</template>
        </Upload>
        <a-button type="primary" @click="touchAdd"><plus-outlined /> 新建短剧</a-button>
      </a-col>
    </a-row>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="pagination"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 入库日期 -->
       <template v-if="column.key === 'total_ep'">
        {{ record[column.key] }}集
      </template>
      <!-- 剧情类型 -->
      <template v-else-if="column.key === 'drama_types'">
        {{ record[column.key].map(item => item.name).join('、') }}
      </template>
      <!-- 风格 -->
      <template v-else-if="column.key === 'style_type'">
        {{ StyleTypes.find(item => item.value === record.style_type)?.text || '-' }}
      </template>
      <!-- 片源 -->
      <template v-else-if="column.key === 'film_type'">
        {{ FilmTypes.find(item => item.value === record.film_type)?.text || '-' }}
      </template>
      <!-- 供应商 -->
      <template v-else-if="column.key === 'film_supplier_id'">
        {{ supplierList.find(s => s.id === record.film_supplier_id)?.name || record.film_supplier_name || '-' }}
      </template>
      <!-- 操作 -->
      <template v-else-if="column.key === 'operation'">
        <a class="operation-item" @click="touchEdit(record)">编辑</a>
        <a class="operation-item" @click="touchMediaManagement(record)">媒资管理</a>
        <a class="operation-item" @click="touchVideoExport(record)">视频翻译</a>
        <a class="operation-item" @click="touchYoutubeContent(record)">油管内容</a>
      </template>
      <template v-else>
        {{ record[column.key] || '-' }}
      </template>
    </template>
  </a-table>
  
  <!-- 服务商弹窗 -->
  <Add ref="RefAdd" @success="getList" @copy-create="onCopyCreate"></Add>
  <!-- 油管内容弹窗 -->
  <Content ref="RefContent" @success="getList"></Content>
  <!-- 媒资管理弹窗 -->
  <MediaManagement ref="RefMediaManagement" @success="getList"></MediaManagement>
  <!-- 视频处理弹窗 -->
  <VideoExport ref="RefVideoExport" @success="getList"></VideoExport>
</template>

<script setup>
import { onBeforeMount, reactive, ref, nextTick } from 'vue'
import { message } from 'ant-design-vue'
// 引入 dayjs 及 扩展函数
import dayjs from 'dayjs'
// 引入公共方法
import Pub from '@/utils/public'
// 引入弹窗组件
import Add from './components-youtube/Add'
// 引入油管内容弹窗组件
import Content from './components-youtube/Content'
// 引入媒资管理弹窗组件
import MediaManagement from './components-youtube/MediaManagement'
// 引入文件上传组件
import Upload from '@/components/Upload'
// 引入视频处理弹窗组件
import VideoExport from './components-youtube/VideoExport'
// 引入 ex2json 转换
import ex2json from "ex2json";
// 引入常量列表
import { StyleTypes, FilmTypes, PlotChannels } from '@/utils/constantList'
// 引入 API
import { ytDramaList, ytBatchImport, supplierAll } from '@/api/admin'

// 弹窗引用
let RefAdd = ref(null)
// 油管内容弹窗引用
let RefContent = ref(null)
// 媒资管理弹窗引用
let RefMediaManagement = ref(null)
// 视频处理弹窗引用
let RefVideoExport = ref(null)
// 搜索条件
let name = ref(undefined)
let nameModel = ref(undefined)
let maleAndFemaleModel = ref(undefined)
let styleTypeModel = ref(undefined)
let filmSupplierIdModel = ref(undefined)
// 供应商列表（下拉选项 + 列表展示用）
let supplierList = ref([])
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '剧名',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '集数',
    dataIndex: 'total_ep',
    key: 'total_ep'
  },
  {
    title: '视频语种',
    dataIndex: 'lang_name',
    key: 'lang_name'
  },
  {
    title: '剧情类型',
    dataIndex: 'drama_types',
    key: 'drama_types'
  },
  {
    title: '风格',
    dataIndex: 'style_type',
    key: 'style_type'
  },
  {
    title: '片源',
    dataIndex: 'film_type',
    key: 'film_type'
  },
  {
    title: '供应商',
    dataIndex: 'film_supplier_id',
    key: 'film_supplier_id'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 供应商下拉模糊匹配
function filterSupplierOption (input, option) {
  const item = supplierList.value.find(s => s.id === option.value)
  const name = item ? item.name : ''
  return String(name).toLowerCase().includes(String(input || '').toLowerCase())
}

onBeforeMount (() => {
  // 获取供应商列表
  supplierAll().then(res => {
    const { code, data } = res
    if (code === 0) supplierList.value = data
  })
  touchSearch()
})

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  // 获取列表
  getList()
}

// 查询
function touchSearch () {
  name.value = nameModel.value
  pagination.current = 1
  getList()
}

// 重置
function touchReset () {
  nameModel.value = undefined
  name.value = undefined
  maleAndFemaleModel.value = undefined
  styleTypeModel.value = undefined
  filmSupplierIdModel.value = undefined
  pagination.current = 1
  getList()
}

// 新建
function touchAdd () {
  // 显示新建弹窗
  RefAdd.value.showDrawer()
}

// 编辑
function touchEdit (record) {
  RefAdd.value.showDrawer(record)
}

// 复制创建：编辑弹窗内点击「复制创建」后，关闭当前弹窗并以拷贝状态重新打开（剧名、集数置空，走新建接口）
function onCopyCreate (record) {
  nextTick(() => {
    RefAdd.value.showDrawer(record, true)
  })
}

// 油管内容
function touchYoutubeContent (record) {
  // 使用nextTick确保组件已经挂载
  nextTick(() => {
    if (RefContent.value) {
      RefContent.value.showDrawer(record)
    } else {
      console.error('Content组件引用为空')
      message.error('组件加载失败，请刷新页面重试')
    }
  })
}

// 媒资管理
function touchMediaManagement (record) {
  // 显示媒资管理弹窗，传入记录数据
  RefMediaManagement.value.showDrawer(record)
}

// 视频处理
function touchVideoExport (record) {
  // 显示视频处理弹窗，传入记录数据
  RefVideoExport.value.showDrawer(record)
}

// 批量上传
function beforeUploadBatchPro (file, fileList) {
  // 转成成 json
  ex2json.parse(file, (code, res) => {
    // 上传服务器
    const list = res[0].list || []
    list.shift();
    const newList = list.filter(item => {
      return !(Array.isArray(item) && item.length === 0)
    })
    ytBatchImport({'data': newList}).then(res => {
      if (res.code === 0) {
        message.success('上传成功')
        // 刷新列表
        getList()
      } else {
        message.error(res.message)
      }
    }).catch(err => {
      message.error(err.message)
    })
  });
  // 返回 false 不进行上传
  return false
}


// 获取列表
function getList () {
  isLoading.value = true
  const params = {
    name: name.value,
    male_and_female: maleAndFemaleModel.value,
    style_type: styleTypeModel.value,
    film_supplier_id: filmSupplierIdModel.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  // TODO: 替换为实际的API调用
  ytDramaList(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 获取短日期格式 (YYYY-MM-DD)
function getShortDate (dateTime) {
  if (!dateTime) return '-'
  return dayjs(dateTime).format('YYYY-MM-DD')
}

// 获取完整日期时间格式 (YYYY-MM-DD HH:mm:ss)
function getFullDateTime (dateTime) {
  if (!dateTime) return '-'
  return dayjs(dateTime).format('YYYY-MM-DD HH:mm:ss')
}
</script>

<style scoped>

.tool-row {
  margin-bottom: 16px;
}

.tool-title {
  text-align: right;
}

.tool-item {
  width: 100%;
}

.table-view {
  background: #fff;
  border-radius: 6px;
}

.operation-item {
  color: #1890ff;
  margin-right: 16px;
  cursor: pointer;
}

.operation-item:hover {
  color: #40a9ff;
}
</style>
